import React from 'react';
import { useIntl } from 'react-intl';

import { isEmpty } from 'lodash';
import moment from 'moment';
import { TUser, useLumaBotFlowSnapshot } from 'ui-model';

import { ContentLoaderChatMessage, Typography } from 'components/v2';

import LumaBotMessage from '../Message/LumaBotMessage';
import { Thread } from '../Thread';

import messages from './LumaBotThread.messages';

export interface ILumaBotThread {
  patientFlowId: string;
  patient: TUser;
}

const LumaBotThread: React.FC<ILumaBotThread> = (props) => {
  const { patient, patientFlowId } = props;
  const { formatMessage } = useIntl();

  const { data, isError, isLoading } = useLumaBotFlowSnapshot({
    flowId: patientFlowId,
    showWholeSession: false,
  });

  const messageHistory = React.useMemo(() => data?.response[0]?.messages || [], [data]);
  const startedAt = data?.response[0]?.startDate || '';
  const title = data?.response[0]?.title || '';

  if (isLoading) return <ContentLoaderChatMessage toRight={false} />;
  if (isError || isEmpty(messageHistory)) return null;

  return (
    <Thread
      initialMessage={formatMessage(messages.defaultText, { title })}
      interlocutor={patient}
      MessageDetailsComponent={
        <Typography variant="supportW500F12" color="inherit">
          {formatMessage(messages.startedAt, { startedAt: moment(startedAt).format('MMM DD, YYYY h:mm A') })}
        </Typography>
      }
    >
      {messageHistory.map((message) => (
        <LumaBotMessage key={`${message.source}@${message.createdAt}`} patient={patient} {...message} />
      ))}
    </Thread>
  );
};

export default LumaBotThread;
